<template>
  <div class="box10">
    <pageTitle title="福利加码&nbsp;&nbsp;强势来袭" titleColor="#02154B" />
    <div class="welfare">
      <div class="top">
        <h1>享传智&头部大厂专属福利</h1>
        <img src="../../../assets/coursePage/ai2/box10/img01.png" />
      </div>
      <div class="bottom">
        <span>入营用户优先享<i>4大头部大厂相关岗位人才输送机会</i></span>
        <span>大模型技术日新月异，入营用户享<i>1年课程免费更新</i></span>
        <span
          >入营用户<i>免费送趋动云算力</i
          ><img src="../../../assets/coursePage/ai2/box10/img02.png"
        /></span>
        <span>AI大模型相关电子书籍<i>免费赠送</i></span>
      </div>
    </div>
    <ul class="content">
      <div>
        <li>
          <div class="left">
            <h1>录播，赠送</h1>
            <p>大模型前置课</p>
          </div>
          <div class="right"><img src="../../../assets/coursePage/ai2/box10/01.png"/></div>
        </li>
        <img
          class="arrow"
          src="../../../assets/coursePage/ai2/box10/img03.png"
        />
      </div>
      <div>
        <li>
          <div class="left">
            <h1>录播，赠送</h1>
            <p>大模型训练营1期课（部分）</p>
          </div>
          <div class="right"><img src="../../../assets/coursePage/ai2/box10/02.png"/></div>
        </li>
        <img
          class="arrow"
          src="../../../assets/coursePage/ai2/box10/img04.png"
        />
      </div>
      <div>
        <li>
          <div class="left">
            <h1>直播，正课</h1>
            <p>AI大模型训练营2期（8周）</p>
          </div>
          <div class="right"><img src="../../../assets/coursePage/ai2/box10/03.png"/></div>
        </li>
        <img
          class="arrow"
          src="../../../assets/coursePage/ai2/box10/img04.png"
        />
      </div>
      <div>
        <li>
          <div class="left">
            <h1>就业指导</h1>
            <p>AI大模型训练营2期 加餐课</p>
          </div>
          <div class="right"><img src="../../../assets/coursePage/ai2/box10/04.png"/></div>
        </li>
      </div>
    </ul>
    <div class="zixun" @click="zixun">
     <h1>限时早鸟价</h1> 
     <p>请点击<img src="../../../assets/coursePage/ai2/box10/img05.png"/>联系咨询师了解
      </p>
    </div>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
export default {
  components: {
    pageTitle,
  },
  data() {
    return {};
  },
  methods: { zixun(name) {
      this.mai("AI大模型训练营", "查看更多", 0, null);
      this.clickZiXun()
    },},
};
</script>

<style lang="scss" scoped>
.box10 {
  padding: 80px 0 0;
  width: 100%;
  margin-top: -50px;
  background: url("../../../assets/coursePage/ai2/box10/bg01.png") no-repeat;
  background-size: cover;
  .welfare {
    margin-top: 48px;
    background: url("../../../assets/coursePage/ai2/box10/bg02.png") center
      center no-repeat;
    background-size: cover;
    height: 904px;
    width: 100%;
    position: relative;
    box-sizing: border-box;
    .top {
      position: absolute;
      top: 2px;
      left: 32px;
      display: flex;
      h1 {
        width: 526px;
        height: 76px;
        background: linear-gradient(270deg, #b3e0ff 0%, #63a3ff 100%);
        border-radius: 33px 33px 33px 0px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 36px;
        color: #ffffff;
        line-height: 76px;
        text-align: left;
        padding-left: 40px;
        box-sizing: border-box;
        font-style: normal;
      }
      img {
        margin-left: -30px;
        width: 126px;
        height: 76px;
      }
    }
    .bottom {
      padding-left: 154px;
      padding-top: 190px;
      padding-right: 86px;
      span {
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        display: block;
        font-size: 30px;
        color: #1b1b1b;
        line-height: 42px;
        text-align: left;
        font-style: normal;
        position: relative;
        margin-bottom: 102px;
        i {
          color: #0066ff;
        }
        img {
          width: 180px;
          height: 82px;
          position: absolute;
          bottom: -20px;
          right: -28px;
        }
      }
    }
    span:nth-child(2) {
      margin-bottom: 100px;
    }
    span:nth-child(3) {
      margin-bottom: 114px;
    }
    span:last-child {
      margin-bottom: 0;
    }
  }
  .content {
    margin: -12px 32px 0;
    background: rgba(255, 255, 255, 0.7);
    box-shadow: 0px 4px 40px 0px rgba(202, 211, 235, 0.3),
      inset 2px 4px 6px 0px #ffffff;
    border-radius: 32px;
    border: 2px solid #ffffff;
    backdrop-filter: blur(16px);
    padding: 36px 40px;

    > div {
      position: relative;
    }
    .arrow {
      position: absolute;
      right: 46px;
      bottom: -34px;
      width: 64px;
      height: 44px;
      z-index: 2;
    }
    li {
      height: 184px;
      box-sizing: border-box;
      background: linear-gradient( 157deg, #E5F1FF 0%, #F4F9FF 100%);
      
      border-radius: 32px;
      border: 2px solid #ffffff;
      backdrop-filter: blur(16px);
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 32px 0 40px;
      margin-bottom: 24px;

      .left {
        h1 {
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          font-size: 32px;
          color: #24375c;
          line-height: 52px;
          text-align: left;
          font-style: normal;
          margin-bottom: 8px;
        }
        p {
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 28px;
          color: #24375c;
          line-height: 44px;
          text-align: left;
          font-style: normal;
        }
      }
      .right {
        width: 88px;
        height: 88px;
       display:flex;
       align-items: center;
       justify-content: center;

        border-radius: 44px;
        background: linear-gradient(180deg, #009cff 0%, #0063ff 100%);
        img{
          width: 46px;
          height: 38px;
        }
      }
    }
    >div:nth-child(3), >div:nth-child(4){
      li{
        background: linear-gradient( 157deg, #FFF6E8 0%, #FFFAF3 100%);
        .right{
          background: linear-gradient( 180deg, #FFCE87 0%, #FF9800 100%);
        }
      }
     
  }
  }
  .zixun{
    background: url("../../../assets/coursePage/ai2/box10/bg03.png") no-repeat;
  background-size: cover;
  height: 196px;
  padding-top: 30px;
  box-sizing: border-box;
  margin-top: 60px;
  h1,p{
    font-family: PingFangSC, PingFang SC;
font-weight: 600;
font-size: 56px;
color: #FFFFFF;
line-height: 68px;
text-align: center;
font-style: normal;
  }
  p{
    font-size: 48px;
    img{
      width: 60px;
      height: 60px;
      position: relative;
      margin:0 10px;
      top: 16px;
    }
  }
  }
}
</style>
